import { render, staticRenderFns } from "./CentralChannel.vue?vue&type=template&id=4b548474&scoped=true&"
import script from "./CentralChannel.vue?vue&type=script&lang=js&"
export * from "./CentralChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b548474",
  null
  
)

export default component.exports